import { render, staticRenderFns } from "./KasTarKoch.vue?vue&type=template&id=e6fbbf82"
import script from "./KasTarKoch.vue?vue&type=script&lang=js"
export * from "./KasTarKoch.vue?vue&type=script&lang=js"
import style0 from "./KasTarKoch.vue?vue&type=style&index=0&id=e6fbbf82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports